import { Link } from "react-router-dom";

export default function SizeGuide() {
  return (
    <div className="max-w-[1100px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="max-w-3xl mb-16">
        <div className="ie-overline text-brand-accent mb-4">
          Care
        </div>

        <h1 className="font-serif text-5xl md:text-6xl tracking-tight">
          Size Guide
        </h1>

        <p className="text-text-secondary text-sm leading-7 mt-6">
          Find the right fit before placing your order.
        </p>
      </div>

      <div className="border border-border overflow-x-auto">
        <table className="w-full text-sm min-w-[600px]">
          <thead className="border-b border-border">
            <tr>
              <th className="text-left p-5 ie-overline">Size</th>
              <th className="text-left p-5 ie-overline">Chest</th>
              <th className="text-left p-5 ie-overline">Waist</th>
              <th className="text-left p-5 ie-overline">Length</th>
            </tr>
          </thead>

          <tbody>
            {["S", "M", "L", "XL", "XXL"].map((size) => (
              <tr key={size} className="border-b border-border last:border-0">
                <td className="p-5 font-serif">{size}</td>
                <td className="p-5 text-text-secondary">—</td>
                <td className="p-5 text-text-secondary">—</td>
                <td className="p-5 text-text-secondary">—</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="text-xs text-text-secondary mt-5 leading-6 max-w-3xl">
        Measurements will vary by garment and fit. Please refer to the
        measurements listed on the individual product page where available.
      </p>

      <div className="mt-10 flex flex-wrap gap-4">
        <Link to="/shop" className="ie-btn-primary">
          Browse collection
        </Link>

        <Link to="/contact" className="ie-btn-ghost">
          Need help choosing?
        </Link>
      </div>
    </div>
  );
}